import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { RELIABILITY } from "@/lib/assessments";
import { cn } from "@/lib/utils";

export const ReliabilityBadge = ({ level, reasons = [], testId }) => {
  const [label, cls] = RELIABILITY[level] || RELIABILITY.medium;
  const chip = <span data-testid={testId} className={cn("inline-flex whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium", cls)}>{label}</span>;
  if (!reasons.length) return chip;
  return (
    <Tooltip><TooltipTrigger asChild>{chip}</TooltipTrigger>
      <TooltipContent className="max-w-xs bg-ink text-white">{reasons.join(" · ")}</TooltipContent></Tooltip>
  );
};
